import cn from 'classnames';
import styles from './styles.scss';
import { createElement, DOMAttributes, forwardRef } from 'react';
import { flattenAppearance } from 'components/Shared/Layout/flattenAppearance';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type OverrideStyleInterface = any;
const appearanceStyles: OverrideStyleInterface = styles;
export type AppearanceTypes = 'primary' | 'secondary' | 'tertiary';
export type ShadowType = 'full' | 'two' | 'three' | boolean;
export type Padding = 'none' | 'less' | 'normal';

export interface BaseProps<TAppearanceTypes> extends DOMAttributes<HTMLElement> {
  id?: string;
  type?: keyof React.ReactHTML;
  key?: string;
  className?: string;
  appearance?: TAppearanceTypes[] | TAppearanceTypes;
  children?: React.ReactNode;
  shadow?: ShadowType;
  lessPadding?: boolean;
  padding?: Padding;
  contentClassName?: string;
  flattenedAppearance?: { [key: string]: boolean } | string;
}

export const Base = forwardRef<HTMLElement, BaseProps<string>>(
  (
    {
      id,
      key,
      type = 'div',
      className,
      appearance = 'primary',
      children,
      shadow = false,
      lessPadding,
      padding = 'normal',
      flattenedAppearance,
      ...props
    },
    ref
  ) =>
    createElement(
      type,
      {
        key,
        id,
        className: cn(
          styles.base,
          {
            [styles.shadow]: !!shadow,
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            [appearanceStyles[typeof shadow === 'string' ? shadow : '']]:
              typeof shadow === 'string',
            [styles.lessPadding]: lessPadding || padding === 'less',
            [styles.normalPadding]: padding === 'normal'
          },
          flattenedAppearance
            ? flattenedAppearance
            : flattenAppearance({ appearance, styles: appearanceStyles }), // eslint-disable-line @typescript-eslint/no-unsafe-assignment
          className
        ),
        ref,
        ...props
      },
      children
    )
);
